import Vue from 'vue'
import Router from 'vue-router'
import Article from '@/components/Article'
import Blog from '@/components/Blog'
import Error from '@/components/Error'
import Exhibition from '@/components/Exhibition'
import Exhibitions from '@/components/Exhibitions'
import ExhibitionsOverview from '@/components/ExhibitionsOverview'
import GenericIndex from '@/components/GenericIndex'
import Home from '@/components/Home'
import InfoPage from '@/components/InfoPage'
import Program from '@/components/Program'
import Programs from '@/components/Programs'
import ProgramsOverview from '@/components/ProgramsOverview'
import Search from '@/components/Search'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      name: 'home',
      path: '/',
      component: Home
    },
    {
      name: 'visit',
      path: '/visit',
      component: GenericIndex
    },
    {
      name: 'visit-page',
      path: '/visit/:id',
      component: InfoPage
    },
    {
      name: 'visit-page-subpage',
      path: '/visit/:id/:subid',
      component: InfoPage
    },
    {
      name: 'exhibitions',
      path: '/exhibitions',
      component: Exhibitions
    },
    {
      name: 'exhibitions-overview',
      path: '/exhibitions/:year',
      component: ExhibitionsOverview
    },
    {
      name: 'exhibition-single',
      path: '/exhibitions/:year/:id',
      component: Exhibition
    },
    {
      name: 'programs',
      path: '/programs',
      component: Programs
    },
    {
      name: 'programs-overview',
      path: '/programs/:category',
      component: ProgramsOverview
    },
    {
      name: 'programs-page',
      path: '/programs/:category/:id',
      component: Program
    },
    {
      name: 'collection',
      path: '/collection',
      component: GenericIndex
    },
    {
      name: 'collection-page',
      path: '/collection/:id',
      component: InfoPage
    },
    {
      name: 'collection-page-subpage',
      path: '/collection/:id/:subid',
      component: InfoPage
    },
    {
      name: 'library',
      path: '/library',
      component: GenericIndex
    },
    {
      name: 'library-page',
      path: '/library/:id',
      component: InfoPage
    },
    {
      name: 'library-page-subpage',
      path: '/library/:id/:subid',
      component: InfoPage
    },
    {
      name: 'learn',
      path: '/learn',
      component: GenericIndex
    },
    {
      name: 'blog',
      path: '/learn/600state',
      component: Blog
    },
    {
      name: 'article',
      path: '/learn/600state/:article',
      component: Article
    },
    {
      name: 'learn-page',
      path: '/learn/:id',
      component: InfoPage
    },
    {
      name: 'learn-page-subpage',
      path: '/learn/:id/:subid',
      component: InfoPage
    },
    {
      name: 'support',
      path: '/support',
      component: GenericIndex
    },
    {
      name: 'support-page',
      path: '/support/:id',
      component: InfoPage
    },
    {
      name: 'support-page-subpage',
      path: '/support/:id/:subid',
      component: InfoPage
    },
    {
      name: 'about',
      path: '/about',
      component: GenericIndex
    },
    {
      name: 'about-page',
      path: '/about/:id',
      component: InfoPage
    },
    {
      name: 'about-page-subpage',
      path: '/about/:id/:subid',
      component: InfoPage
    },
    {
      name: 'search',
      path: '/search',
      component: Search
    },
    {
      path: '/a',
      redirect: '/b'
    },
    {
      name: '404',
      path: '*',
      component: Error
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js